<template>
<!-- 保司管理 -->
  <div class='content main-container'>
    <Tabs v-model="tabId" :animated="false" @on-click="tabChange" v-if="$units.superviseShowVal()">
      <TabPane label="保险公司" name="1"></TabPane>
      <TabPane label="合作通道" name="2"></TabPane>
    </Tabs>
    <company-page v-show="tabId==1"></company-page>
    <channel-page v-show="tabId==2" ref="channelPage"></channel-page>
  </div>
</template>
<script>
import companyPage from "./components/companyPage";
import channelPage from "./components/channelPage";
export default {
  components:{
    companyPage,
    channelPage,
  },
  data: () => ({
    tabId:"1",
  }),
  
  methods: {
    tabChange(){
      if(this.tabId == 2){
        this.$refs.channelPage.init();
      }
    },
  },
}
</script>
<style lang='scss' scoped>
@import './insuranceManage';
</style>
